<template>
  <div id="app-main" class="app-main-wrap">
    <div class="app-main-scroller">
      <section class="app-main">
        <transition name="fade" mode="out-in">
          <router-view class="router-body" />
        </transition>
        <div class="copyright-tip">
          CopyRight©青岛海检集团有限公司&nbsp;&nbsp;&nbsp;&nbsp;鲁ICP备14014787号-8
        </div>
      </section>
    </div>
    <el-backtop target=".app-main-scroller"></el-backtop>
  </div>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    name() {
      return this.g_Config.COPYRIGHT
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'app-main-wrap',
  (
    --app-main-bg-color: #051434,
    --copyright-tip-color: rgba(#fff, 0.35)
  ),
  (
    --app-main-bg-color: #f1f5f8,
    --copyright-tip-color: rgba(#192227, 0.35)
  )
);

.app-main-wrap {
  @include adaptation(
    (
      --app-main-wrap-padding: 6px,
      --app-main-scroller-padding: 10px 10px 0 10px
    )
  );
  $app-main-wrap-height: calc(100vh - var(--base-navbar-height));
  $app-main-scroller-height: calc(
    100vh - var(--base-navbar-height) - 2 * var(--app-main-wrap-padding)
  );

  width: 100%;
  height: $app-main-wrap-height;
  background-color: var(--app-main-bg-color);
  padding: var(--app-main-wrap-padding);

  .app-main-scroller {
    width: 100%;
    height: $app-main-scroller-height;
    padding: var(--app-main-scroller-padding);
    overflow: auto;
  }

  .app-main {
    min-width: calc(
      var(--base-design-width) - var(--base-menu-width) - 2 * var(--base-main-section-padding)
    );

    .router-body {
      min-height: var(--base-main-router-body-avaliable-height);
    }

    .copyright-tip {
      text-align: center;
      font-size: var(--base-main-copyright-tips-fontsize);
      line-height: var(--base-main-copyright-tips-height);
      height: var(--base-main-copyright-tips-height);
      margin-top: var(--base-main-copyright-tips-margin-top);
      color: var(--copyright-tip-color);
    }
  }
}
</style>
